import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, ViewChild, NgModule } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject, Subject } from 'rxjs';
import { saveAs } from 'file-saver';
import { map, take, pluck, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as moment from 'moment';
import * as i1$1 from '@angular/forms';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'environment-configurations';
import * as i6 from 'primeng/api';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import { DeleteDialogConfigurations } from 'dialog-configuration-library';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i3 from 'ngx-toastr';
import * as i4 from 'custom-button-action';
import * as i5 from 'vd-custom-file-upload';
import * as i7 from 'file-upload-library';
import * as i8 from 'primeng/dynamicdialog';
import * as i9 from 'reference-library';
import * as i10 from '@angular/common';
import * as i11 from 'primeng/toast';
import { ToastModule } from 'primeng/toast';
import * as i12 from 'primeng/confirmdialog';
import * as i13 from 'primeng/table';
import * as i14 from 'primeng/calendar';
import * as i15 from 'primeng/radiobutton';
import * as i16 from 'primeng/fileupload';
import * as i17 from 'primeng/dropdown';
import * as i18 from 'primeng/inputtext';
import * as i19 from 'primeng/inputnumber';
import * as i20 from 'primeng/button';
import * as i21 from 'primeng/tooltip';
import { PrimengLibraryModule } from 'primeng-library';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { StyleClassModule } from 'primeng/styleclass';

class CreateProjectTimesheetService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    downloadTemplate() {
        return this.http.get('/vd/formBuilder/project/timesheet/template/XLX/download').pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    downloadTemplateDocument(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(file => {
            const blob = new Blob([file], { type: 'application/vnd.ms-excel;charset=utf-8' });
            saveAs(blob, fileName);
        });
    }
    uploadDocument(moduleId, payload) {
        return this.http.post('/vd/formBuilder/project/timesheet/module/' + moduleId + '/upload/timesheet', payload).pipe(map((response) => {
            if (response) {
                return response;
            }
        }));
    }
    getProjectList(groupName) {
        var grpName = this.toEncrypt(groupName).toUpperCase();
        return this.http.get(`/vd/dataSource/${grpName}/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getBulkUploadFlag() {
        return this.http.get(`/vd/formBuilder/employee/project/timesheetBulkuploadConfiguration`).pipe(pluck("data"), map((data) => {
            return data;
        }));
    }
    getEditTimesheetDetails(Id) {
        var id = this.toEncrypt(Id.toString());
        return this.http.get(`/vd/formBuilder/employee/project/timesheet/${id}/details`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
    getTimeSheetDetails(startDate) {
        return this.http.get(`/vd/formBuilder/timesheet/employee/project/timesheet?date=${startDate}`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
CreateProjectTimesheetService.ɵfac = function CreateProjectTimesheetService_Factory(t) { return new (t || CreateProjectTimesheetService)(i0.ɵɵinject(i1.HttpClient)); };
CreateProjectTimesheetService.ɵprov = i0.ɵɵdefineInjectable({ token: CreateProjectTimesheetService, factory: CreateProjectTimesheetService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateProjectTimesheetService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["credential"];
const _c1 = ["fubauto"];
const _c2 = ["dropDownThing"];
function CreateProjectTimesheetComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "i", 4);
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r2 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(message_r2.message);
} }
function CreateProjectTimesheetComponent_form_4_div_1_div_1_p_radioButton_3_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-radioButton", 32);
    i0.ɵɵlistener("click", function CreateProjectTimesheetComponent_form_4_div_1_div_1_p_radioButton_3_Template_p_radioButton_click_0_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(4); return ctx_r14.uploadtoggle("1", $event); });
    i0.ɵɵelementEnd();
} }
function CreateProjectTimesheetComponent_form_4_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtemplate(3, CreateProjectTimesheetComponent_form_4_div_1_div_1_p_radioButton_3_Template, 1, 0, "p-radioButton", 30);
    i0.ɵɵelementStart(4, "p-radioButton", 31);
    i0.ɵɵlistener("click", function CreateProjectTimesheetComponent_form_4_div_1_div_1_Template_p_radioButton_click_4_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return ctx_r16.uploadtoggle("2", $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r10.hideUploadOption);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", 2);
} }
function CreateProjectTimesheetComponent_form_4_div_1_div_2_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵelementStart(2, "span", 47);
    i0.ɵɵtext(3, "You have Uploaded:");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.fileName, "");
} }
const _c3 = function (a0) { return { disabledView: a0 }; };
function CreateProjectTimesheetComponent_form_4_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "div", 27);
    i0.ɵɵelementStart(3, "div", 29);
    i0.ɵɵelementStart(4, "p", 34);
    i0.ɵɵlistener("click", function CreateProjectTimesheetComponent_form_4_div_1_div_2_Template_p_click_4_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(3); return ctx_r20.downloadTemplateFile(); });
    i0.ɵɵelementStart(5, "i");
    i0.ɵɵtext(6, "Download Timesheet Template ");
    i0.ɵɵelement(7, "i", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 27);
    i0.ɵɵelementStart(9, "div", 36);
    i0.ɵɵelementStart(10, "div", 37);
    i0.ɵɵelementStart(11, "div", 38);
    i0.ɵɵelementStart(12, "p-fileUpload", 39, 40);
    i0.ɵɵlistener("uploadHandler", function CreateProjectTimesheetComponent_form_4_div_1_div_2_Template_p_fileUpload_uploadHandler_12_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(3); return ctx_r22.FileUpload($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, CreateProjectTimesheetComponent_form_4_div_1_div_2_div_14_Template, 5, 1, "div", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 42);
    i0.ɵɵelementStart(16, "div", 43);
    i0.ɵɵelementStart(17, "button", 44);
    i0.ɵɵlistener("click", function CreateProjectTimesheetComponent_form_4_div_1_div_2_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r21); const ctx_r23 = i0.ɵɵnextContext(3); return ctx_r23.saveDocument(); });
    i0.ɵɵtext(18, " Save ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 45);
    i0.ɵɵelementStart(20, "button", 46);
    i0.ɵɵlistener("click", function CreateProjectTimesheetComponent_form_4_div_1_div_2_Template_button_click_20_listener() { i0.ɵɵrestoreView(_r21); const ctx_r24 = i0.ɵɵnextContext(3); return ctx_r24.clear(); });
    i0.ɵɵtext(21, " Clear ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c3, !ctx_r11.isChecked));
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("disabled", ctx_r11.disableFileUpload)("auto", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r11.disableFileUpload);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !ctx_r11.disableFileUpload);
} }
function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th", 50);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th", 51);
    i0.ɵɵtext(5, "Projects");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 52);
    i0.ɵɵtext(7, "Activity");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 53);
    i0.ɵɵtext(9, "Total Hours");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "th", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r25 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, item_r25.date, "fullDate"));
} }
function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 60);
    i0.ɵɵlistener("click", function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r37); const i_r31 = i0.ɵɵnextContext().rowIndex; const item_r25 = i0.ɵɵnextContext().$implicit; const ctx_r35 = i0.ɵɵnextContext(3); return ctx_r35.deleteRow(i_r31, item_r25); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r25 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("disabled", !item_r25.editable);
} }
function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 61);
    i0.ɵɵlistener("click", function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r42); const item_r25 = i0.ɵɵnextContext(2).$implicit; const ctx_r40 = i0.ɵɵnextContext(3); return ctx_r40.addRow(item_r25); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r25 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("disabled", !item_r25.editable);
} }
const _c4 = function () { return { standalone: true }; };
function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 54);
    i0.ɵɵtemplate(2, CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_button_2_Template, 1, 1, "button", 55);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 51);
    i0.ɵɵelementStart(4, "p-dropdown", 56);
    i0.ɵɵlistener("ngModelChange", function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_Template_p_dropdown_ngModelChange_4_listener($event) { const rowData_r32 = ctx.$implicit; return rowData_r32.projectId = $event; })("onChange", function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_Template_p_dropdown_onChange_4_listener($event) { i0.ɵɵrestoreView(_r47); const i_r31 = ctx.rowIndex; const item_r25 = i0.ɵɵnextContext().$implicit; const ctx_r45 = i0.ɵɵnextContext(3); ctx_r45.getProjectValue($event, i_r31, item_r25); return ctx_r45.setFormData($event, "projectId", item_r25, i_r31); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 52);
    i0.ɵɵelementStart(6, "input", 57);
    i0.ɵɵlistener("ngModelChange", function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_Template_input_ngModelChange_6_listener($event) { const rowData_r32 = ctx.$implicit; return rowData_r32.activity = $event; })("change", function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_Template_input_change_6_listener($event) { i0.ɵɵrestoreView(_r47); const i_r31 = ctx.rowIndex; const item_r25 = i0.ɵɵnextContext().$implicit; const ctx_r49 = i0.ɵɵnextContext(3); return ctx_r49.setFormData($event, "activity", item_r25, i_r31); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 53);
    i0.ɵɵelementStart(8, "p-inputNumber", 58);
    i0.ɵɵlistener("ngModelChange", function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_Template_p_inputNumber_ngModelChange_8_listener($event) { const rowData_r32 = ctx.$implicit; return rowData_r32.time = $event; })("onInput", function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_Template_p_inputNumber_onInput_8_listener($event) { i0.ɵɵrestoreView(_r47); const i_r31 = ctx.rowIndex; const item_r25 = i0.ɵɵnextContext().$implicit; const ctx_r52 = i0.ɵɵnextContext(3); return ctx_r52.setFormData($event, "time", item_r25, i_r31); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 53);
    i0.ɵɵtemplate(10, CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_button_10_Template, 1, 1, "button", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r31 = ctx.rowIndex;
    const rowData_r32 = ctx.$implicit;
    const item_r25 = i0.ɵɵnextContext().$implicit;
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i_r31 != 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", rowData_r32.projectId)("ngModelOptions", i0.ɵɵpureFunction0(14, _c4))("options", ctx_r27.getProjectList)("autoDisplayFirst", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(15, _c4))("ngModel", rowData_r32.activity)("disabled", !item_r25.editable);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", rowData_r32.time)("ngModelOptions", i0.ɵɵpureFunction0(16, _c4))("min", 0)("max", 20)("disabled", !item_r25.editable);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (item_r25 == null ? null : item_r25.details == null ? null : item_r25.details.length) == i_r31 + 1);
} }
function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_4_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵelementStart(2, "td", 65);
    i0.ɵɵtext(3, " Total exceeds 20 hours for one or more weekdays. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "td", 62);
    i0.ɵɵelementStart(2, "td", 63);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "td");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_4_ng_container_5_Template, 4, 0, "ng-container", 64);
} if (rf & 2) {
    const item_r25 = i0.ɵɵnextContext().$implicit;
    const ctx_r28 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", item_r25.dailyTotal, " Hours");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r28.projecttimesheetForm.hasError("maxSumExceeded"));
} }
function CreateProjectTimesheetComponent_form_4_div_1_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "p-table", 48);
    i0.ɵɵtemplate(2, CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_2_Template, 11, 4, "ng-template", 17);
    i0.ɵɵtemplate(3, CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_3_Template, 11, 17, "ng-template", 18);
    i0.ɵɵtemplate(4, CreateProjectTimesheetComponent_form_4_div_1_div_14_ng_template_4_Template, 6, 2, "ng-template", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r25 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", item_r25.details)("selectionMode", item_r25.editable ? "row" : "none");
} }
function CreateProjectTimesheetComponent_form_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, CreateProjectTimesheetComponent_form_4_div_1_div_1_Template, 5, 2, "div", 20);
    i0.ɵɵtemplate(2, CreateProjectTimesheetComponent_form_4_div_1_div_2_Template, 22, 7, "div", 21);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵelementStart(4, "div", 22);
    i0.ɵɵelementStart(5, "div", 23);
    i0.ɵɵelementStart(6, "h6", 24);
    i0.ɵɵtext(7, "From");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "p-calendar", 25);
    i0.ɵɵlistener("onSelect", function CreateProjectTimesheetComponent_form_4_div_1_Template_p_calendar_onSelect_8_listener() { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(2); return ctx_r57.resetToDate(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 23);
    i0.ɵɵelementStart(10, "h6", 24);
    i0.ɵɵtext(11, "To");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "p-calendar", 26);
    i0.ɵɵlistener("onSelect", function CreateProjectTimesheetComponent_form_4_div_1_Template_p_calendar_onSelect_12_listener() { i0.ɵɵrestoreView(_r58); const ctx_r59 = i0.ɵɵnextContext(2); return ctx_r59.getProjectDetailsByDate(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 27);
    i0.ɵɵtemplate(14, CreateProjectTimesheetComponent_form_4_div_1_div_14_Template, 5, 2, "div", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.isEditMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.isEditMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c3, ctx_r3.isChecked));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true)("maxDate", ctx_r3.maximumDate);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("showIcon", true)("maxDate", ctx_r3.maximumDate)("disabled", !ctx_r3.fromDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.timesheetArrObj);
} }
function CreateProjectTimesheetComponent_form_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 66);
    i0.ɵɵelement(1, "div", 29);
    i0.ɵɵelementStart(2, "h6", 47);
    i0.ɵɵtext(3, "Rejected Reason: ");
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r4.getEditTimesheetData == null ? null : ctx_r4.getEditTimesheetData.reason) ? ctx_r4.getEditTimesheetData == null ? null : ctx_r4.getEditTimesheetData.reason : "NA");
} }
function CreateProjectTimesheetComponent_form_4_div_7_p_dropdown_1_Template(rf, ctx) { if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dropdown", 69, 70);
    i0.ɵɵlistener("ngModelChange", function CreateProjectTimesheetComponent_form_4_div_7_p_dropdown_1_Template_p_dropdown_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r62 = i0.ɵɵnextContext(3); return ctx_r62.configurations.documentTypeDropdownCode = $event; })("onChange", function CreateProjectTimesheetComponent_form_4_div_7_p_dropdown_1_Template_p_dropdown_onChange_0_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r64 = i0.ɵɵnextContext(3); return ctx_r64.onDocumentTypeChange($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r60.configurations.disableControls)("options", ctx_r60.listDocumentTypes)("ngModel", ctx_r60.configurations.documentTypeDropdownCode)("autoDisplayFirst", false);
} }
function CreateProjectTimesheetComponent_form_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵtemplate(1, CreateProjectTimesheetComponent_form_4_div_7_p_dropdown_1_Template, 2, 4, "p-dropdown", 68);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.listDocumentTypes.length);
} }
function CreateProjectTimesheetComponent_form_4_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 71);
    i0.ɵɵelementStart(1, "h6", 72);
    i0.ɵɵtext(2, "Document Type Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 73);
    i0.ɵɵlistener("ngModelChange", function CreateProjectTimesheetComponent_form_4_div_8_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(2); return ctx_r65.otherName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r6.otherName);
} }
function CreateProjectTimesheetComponent_form_4_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 74);
    i0.ɵɵelementStart(1, "p-fileUpload", 75, 76);
    i0.ɵɵlistener("uploadHandler", function CreateProjectTimesheetComponent_form_4_div_9_Template_p_fileUpload_uploadHandler_1_listener($event) { i0.ɵɵrestoreView(_r69); const _r67 = i0.ɵɵreference(2); const ctx_r68 = i0.ɵɵnextContext(2); return ctx_r68.onUploadHandle($event, _r67); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r7.configurations.disableControls || ctx_r7.configurations.documentTypeDropdownCode == "")("auto", true);
} }
function CreateProjectTimesheetComponent_form_4_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th", 77);
    i0.ɵɵtext(2, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 77);
    i0.ɵɵtext(4, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Actions ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CreateProjectTimesheetComponent_form_4_ng_template_15_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵelementStart(1, "button", 83);
    i0.ɵɵlistener("click", function CreateProjectTimesheetComponent_form_4_ng_template_15_div_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r76); const file_r70 = i0.ɵɵnextContext().$implicit; const ctx_r74 = i0.ɵɵnextContext(2); return ctx_r74.openDoc(file_r70); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r70 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !file_r70.fileLocation);
} }
function CreateProjectTimesheetComponent_form_4_ng_template_15_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r80 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵelementStart(1, "button", 84);
    i0.ɵɵlistener("click", function CreateProjectTimesheetComponent_form_4_ng_template_15_div_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r80); const file_r70 = i0.ɵɵnextContext().$implicit; const ctx_r78 = i0.ɵɵnextContext(2); return ctx_r78.download(file_r70); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CreateProjectTimesheetComponent_form_4_ng_template_15_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r83 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵelementStart(1, "button", 85);
    i0.ɵɵlistener("click", function CreateProjectTimesheetComponent_form_4_ng_template_15_div_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r83); const file_r70 = i0.ɵɵnextContext().$implicit; const ctx_r81 = i0.ɵɵnextContext(2); return ctx_r81.deleteDocumentTypeLis(file_r70); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r73 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r73.configurations.disableControls);
} }
function CreateProjectTimesheetComponent_form_4_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    const _r85 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 77);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 77);
    i0.ɵɵelementStart(4, "a", 78);
    i0.ɵɵlistener("click", function CreateProjectTimesheetComponent_form_4_ng_template_15_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r85); const file_r70 = ctx.$implicit; const ctx_r84 = i0.ɵɵnextContext(2); return ctx_r84.openDoc(file_r70); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 79);
    i0.ɵɵelementStart(7, "div", 80);
    i0.ɵɵtemplate(8, CreateProjectTimesheetComponent_form_4_ng_template_15_div_8_Template, 2, 1, "div", 81);
    i0.ɵɵtemplate(9, CreateProjectTimesheetComponent_form_4_ng_template_15_div_9_Template, 2, 0, "div", 81);
    i0.ɵɵtemplate(10, CreateProjectTimesheetComponent_form_4_ng_template_15_div_10_Template, 2, 1, "div", 81);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r70 = ctx.$implicit;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", file_r70.fileCategory ? file_r70.fileCategory.code === "OTHER" ? file_r70.fileCtaegoryOtherName ? file_r70.fileCategory.name + "-" + file_r70.fileCtaegoryOtherName : file_r70.fileCategory.name : file_r70.fileCategory.name : "-", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", file_r70 == null ? null : file_r70.fileName, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r9.configurations.isViewEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", file_r70.fileLocation && ctx_r9.configurations.isDownloadEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.configurations.isDeleteEnabled);
} }
function CreateProjectTimesheetComponent_form_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 5);
    i0.ɵɵtemplate(1, CreateProjectTimesheetComponent_form_4_div_1_Template, 15, 11, "div", 6);
    i0.ɵɵtemplate(2, CreateProjectTimesheetComponent_form_4_div_2_Template, 6, 1, "div", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵelementStart(4, "label", 9);
    i0.ɵɵtext(5, " Upload Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 10);
    i0.ɵɵtemplate(7, CreateProjectTimesheetComponent_form_4_div_7_Template, 2, 1, "div", 11);
    i0.ɵɵtemplate(8, CreateProjectTimesheetComponent_form_4_div_8_Template, 4, 1, "div", 12);
    i0.ɵɵtemplate(9, CreateProjectTimesheetComponent_form_4_div_9_Template, 3, 2, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 14);
    i0.ɵɵelementStart(11, "h6", 15);
    i0.ɵɵtext(12, "List of Uploaded Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "p-table", 16);
    i0.ɵɵtemplate(14, CreateProjectTimesheetComponent_form_4_ng_template_14_Template, 7, 0, "ng-template", 17);
    i0.ɵɵtemplate(15, CreateProjectTimesheetComponent_form_4_ng_template_15_Template, 11, 5, "ng-template", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.projecttimesheetForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.getEditTimesheetData == null ? null : ctx_r1.getEditTimesheetData.reason);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c3, ctx_r1.isChecked));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c3, ctx_r1.isChecked));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.configurations.isDocumentTypeRequired);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.configurations.documentTypeDropdownCode === "OTHER");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.configurations.isDocumentUploadRequired);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c3, ctx_r1.isChecked));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r1.uploadedFiles)("scrollable", true);
} }
class CreateProjectTimesheetComponent {
    constructor(formBuilder, cdr, CreateProjectTimesheetService, toastr, customButtonActionService, VdCustomFileUploadService, confirmationService, messageService, primengConfig, toasterService, uploadService, vdCustomFileUploadService, dialogService, referenceLibraryService, datePipe) {
        this.formBuilder = formBuilder;
        this.cdr = cdr;
        this.CreateProjectTimesheetService = CreateProjectTimesheetService;
        this.toastr = toastr;
        this.customButtonActionService = customButtonActionService;
        this.VdCustomFileUploadService = VdCustomFileUploadService;
        this.confirmationService = confirmationService;
        this.messageService = messageService;
        this.primengConfig = primengConfig;
        this.toasterService = toasterService;
        this.uploadService = uploadService;
        this.vdCustomFileUploadService = vdCustomFileUploadService;
        this.dialogService = dialogService;
        this.referenceLibraryService = referenceLibraryService;
        this.datePipe = datePipe;
        this.documentTypeDropdownCode = "";
        this.observableSubscription$ = new Subject();
        this.selecteddatelist = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        this.fromDate = null;
        this.toDate = null;
        this.maximumDate = new Date();
        this.minimumDate = new Date(1999, 10 - 1, 25);
        this.selectedData = [];
        this.mondayTotal = 0;
        this.tuesdayTotal = 0;
        this.wednesdayTotal = 0;
        this.thursdayTotal = 0;
        this.fridayTotal = 0;
        this.saturdayTotal = 0;
        this.sundayTotal = 0;
        this.dailytotalsummary = 0;
        this.weeklyTotalSummary = 0;
        this.rangeDates = [new Date(), new Date()];
        this.selecteddaterange = [];
        this.projectListGroup = "FB_PROJECTS_BY_COMPANY";
        this.getProjectList = [];
        this.getEditTimesheetData = [];
        this.initialValues = [];
        this.uploadedFiles = [];
        this.total = [];
        this.isChecked = true;
        this.disableFileUpload = false;
        this.previousFromdate = '';
        this.previousTodate = '';
        this.radios = [{
                label: "Upload Timesheet",
                value: true,
                inputId: 1
            }, {
                label: "Manual Entry",
                value: false,
                inputId: 2
            }];
        this.displayBasic = false;
        this.inputflag = false;
        this.uploadflag = false;
        this.filepayload = new FormData();
        this.timesheetArrObj = [];
        this.datesArr = [];
        this.isEditMode = false;
        this.hideUploadOption = false;
        this.companyId = parseInt(sessionStorage.getItem("companyId"));
        this.uploadedFiles = [];
        this.listDocumentTypes = [];
        this.configurations = {
            disableControls: false,
            isDocumentTypeRequired: true,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            postApiUrl: '',
            getApiUrl: '',
            deleteApiUrl: '',
            documentTypeDropdownCode: ''
        };
        this.otherName = '';
    }
    onCompare(_left, _right) {
        return -1;
    }
    ngOnInit() {
        var _a;
        console.log(this.inputParams);
        this.loading = true;
        let type = '1';
        // this.listDataId = 'idToGetDetails' in sessionStorage ? parseInt(sessionStorage.getItem('idToGetDetails')) : null;
        // if (this.listDataId) {
        //   this.CreateProjectTimesheetService.getEditTimesheetDetails(this.listDataId)
        //     .pipe(takeUntil(this.observableSubscription$))
        //     .subscribe((response) => {         
        //       //this.VdCustomFileUploadService.sendtimesheetCheckbocValue(false);
        //       let responseObj = response?.data || null;
        //       this.processEditResponse(responseObj);   
        //     });
        // }
        this.listDataId = 'idToGetDetails' in sessionStorage ? parseInt(sessionStorage.getItem('idToGetDetails')) : null;
        if (this.listDataId) {
            this.CreateProjectTimesheetService.getEditTimesheetDetails(this.listDataId)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                this.getEditTimesheetData = (response === null || response === void 0 ? void 0 : response.data) || null;
                this.fromDate = this.datePipe.transform(this.getEditTimesheetData.fromDate, 'MM/dd/yyyy');
                this.toDate = this.datePipe.transform(this.getEditTimesheetData.toDate, 'MM/dd/yyyy');
                type = '2';
                this.loading = false;
                this.timesheetArrObj = response.data.projectTimesheetDetails;
                this.isEditMode = true;
                this.isChecked = false;
                this.VdCustomFileUploadService.sendtimesheetCheckbocValue(false);
                this.group.addControl(this.inputParams.name, new FormGroup({
                    fromDate: new FormControl(this.fromDate),
                    toDate: new FormControl(this.toDate),
                    type: new FormControl(type),
                    projectTimesheetDetails: new FormControl(this.timesheetArrObj),
                    uploadedFile: new FormControl(),
                    startDate: new FormControl(this.fromDate),
                    endDate: new FormControl(this.toDate)
                }));
                this.projecttimesheetForm = (this.group.controls[this.inputParams.name]);
                console.log(this.projecttimesheetForm);
                this.projecttimesheetForm.updateValueAndValidity();
                this.getProjectDetailsByDate(true);
            });
        }
        // if(this.inputParams.value && this.inputParams.value?.fromDate){
        //   this.fromDate = new Date(this.inputParams.value.fromDate);
        //   this.toDate = new Date(this.inputParams.value.toDate);
        //   type = '2';
        //   this.timesheetArrObj = this.inputParams.value.projectTimesheetDetails;      
        //   this.isEditMode = true;  
        //   this.isChecked = false;
        //   this.VdCustomFileUploadService.sendtimesheetCheckbocValue(false);
        // }
        else {
            type = "1";
            this.isChecked = true;
            this.isEditMode = false;
            this.getUploadDisableFlag();
            // const typeControl = new FormControl(this.hideUploadOption ? '2' : '1');
            this.group.addControl(this.inputParams.name, new FormGroup({
                fromDate: new FormControl(this.fromDate),
                toDate: new FormControl(this.toDate),
                type: new FormControl(type),
                projectTimesheetDetails: new FormControl(this.timesheetArrObj),
                uploadedFile: new FormControl(),
                startDate: new FormControl(this.fromDate),
                endDate: new FormControl(this.toDate)
            }));
            this.projecttimesheetForm = (this.group.controls[this.inputParams.name]);
            console.log(this.projecttimesheetForm);
            this.projecttimesheetForm.updateValueAndValidity();
            this.VdCustomFileUploadService.sendtimesheetCheckbocValue(true);
            this.getProjectDetailsByDate();
        }
        // this.group.addControl(
        //   this.inputParams.name,
        //   new FormGroup({
        //     fromDate: new FormControl(this.fromDate),
        //     toDate: new FormControl(this.toDate),
        //     type: new FormControl(type),
        //     projectTimesheetDetails: new FormControl(this.timesheetArrObj),
        //     uploadedFile: new FormControl(),
        //     startDate: new FormControl(this.fromDate),
        //     endDate: new FormControl(this.toDate)
        //   })
        // );
        // this.projecttimesheetForm = <FormGroup>(
        //   this.group.controls[this.inputParams.name]
        // );
        // console.log(this.projecttimesheetForm);
        // this.projecttimesheetForm.updateValueAndValidity();   
        // if(this.isEditMode){
        //   this.getProjectDetailsByDate(true);
        // }else{
        //   this.getProjectDetailsByDate();
        // }
        if (this.projecttimesheetForm) {
            this.projecttimesheetForm.valueChanges.subscribe(val => {
                if (val['fromDate']) {
                    this.fromDate = val['fromDate'];
                }
            });
        }
        this.primengConfig.ripple = true;
        this.userType = sessionStorage.getItem("userTypeRole");
        this.configurations.documentTypeDropdownCode = "";
        const selectedMenu = JSON.parse(sessionStorage.getItem("selectedMenu"));
        const menuId = ((_a = this.formBuilderInfo) === null || _a === void 0 ? void 0 : _a.menuId) || (selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.value);
        if (menuId) {
            this.fileUploadConfigurations = {
                disableControls: false,
                isDocumentTypeRequired: true,
                isDocumentUploadRequired: true,
                isViewEnabled: true,
                isDownloadEnabled: true,
                isDeleteEnabled: true,
                getDocTypeApiUrl: `/referenceLibrary/OTHERDOCS`,
                getApiUrl: `/vd/formBuilder/fetchAll/uploadedDocs/`,
                postApiUrl: `/vd/formBuilder/uploadDoc/formData/company/${this.companyId}/module/${this.formBuilderInfo.moduleId}/menu/${menuId}/form/${this.formBuilderInfo.id}?`,
                deleteApiUrl: `/vd/formBuilder/formDataDocs/delete/`,
                documentTypeDropdownCode: "",
                isFormBuilder: true,
                fbFormDataId: this.dataFormId
                    ? this.dataFormId
                    : "formDataId" in sessionStorage
                        ? parseInt(sessionStorage.getItem("formDataId"))
                        : null,
            };
            if (this.fileUploadConfigurations) {
                this.configurations = Object.assign({}, this.fileUploadConfigurations);
                this.dataFormId = this.configurations.fbFormDataId
                    ? this.configurations.fbFormDataId
                    : "";
                if (this.fileUploadConfigurations.fbFormDataId) {
                    this.getDocuments();
                }
            }
            if (this.configurations.isDocumentTypeRequired) {
                this.getDocumentTypeList();
            }
        }
    }
    // processEditResponse(response){
    //   this.getEditTimesheetData = response || null;   
    //         this.fromDate = new Date(this.getEditTimesheetData.fromDate);//this.datePipe.transform(this.getEditTimesheetData.fromDate, 'MM/dd/yyyy');
    //         this.toDate = new Date(this.getEditTimesheetData.toDate);//this.datePipe.transform(this.getEditTimesheetData.toDate, 'MM/dd/yyyy');
    //         this.timesheetArrObj = this.getEditTimesheetData.projectTimesheetDetails;     
    //         this.isChecked = false;
    //         this.isEditMode = true;            
    //         this.setUpTimeSheetEl("2");
    // }
    // setUpTimeSheetEl(type){
    //   this.group.addControl(
    //     this.inputParams.name,
    //     new FormGroup({
    //       fromDate: new FormControl(this.fromDate),
    //       toDate: new FormControl(this.toDate),
    //       type: new FormControl(type),
    //       projectTimesheetDetails: new FormControl(this.timesheetArrObj),
    //       uploadedFile: new FormControl(),
    //       startDate: new FormControl(this.fromDate),
    //       endDate: new FormControl(this.toDate)
    //     })
    //   );
    //   this.projecttimesheetForm = <FormGroup>(
    //     this.group.controls[this.inputParams.name]
    //   );
    //   console.log(this.projecttimesheetForm);
    //   this.projecttimesheetForm.updateValueAndValidity();   
    //   //this.getProjectDetailsByDate('reload');
    // }
    getDocumentTypeList() {
        // this.configurations.documentTypeDropdownCode = '';
        this.referenceLibraryService.getReferenceDocTypeData(this.configurations.getDocTypeApiUrl)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.listDocumentTypes = response;
            // this.configurations.documentTypeDropdownCode = "OTHERDOCS";
        });
    }
    getUploadDisableFlag() {
        this.CreateProjectTimesheetService.getBulkUploadFlag()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.loading = false;
            if (response) {
                this.hideUploadOption = response.timesheetConf === 'No' ? true : false;
                const typeControl = new FormControl(this.hideUploadOption ? '2' : '1');
                this.projecttimesheetForm.addControl('type', typeControl);
                if (this.hideUploadOption) {
                    typeControl.setValue('2');
                    this.isChecked = false;
                    this.confirm('Yes', "2");
                }
            }
        });
    }
    onDocumentTypeChange(selectedOption) {
        const selectedDoc = this.listDocumentTypes.find(item => item.code === selectedOption.value);
        if (selectedDoc) {
            this.refId = selectedDoc.id;
            this.configurations.documentTypeDropdownCode = selectedDoc.code;
        }
    }
    onUploadHandle(event, fubauto) {
        if (this.configurations.documentTypeDropdownCode === 'OTHER' && this.otherName.trim() === '') {
            CustomErrorToastComponent.showErrorToast(this.toastr, 'Document Type Name is required');
            fubauto.clear();
            return false;
        }
        const file = event.files[0];
        file.fileName = event.files[0].name;
        const payload = new FormData();
        payload.append('file', file, file.name);
        this.group.controls[this.inputParams.name].patchValue({
            uploadedFile: event.files[0],
        });
        let apiUrl;
        apiUrl = `${this.configurations.postApiUrl}` + `${this.configurations.documentTypeDropdownCode ? 'documentCategory=' + this.configurations.documentTypeDropdownCode : ''}` + `${this.refId ? '&refId=' + this.refId : ''}` + `${this.dataFormId ? '&formDataId=' + this.dataFormId : ''}`;
        this.uploadService.uploadDocument(apiUrl, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.toasterService.success(response.message, 'Success');
            this.cdr.detectChanges();
            this.otherName = '';
            if (this.configurations.isFormBuilder) {
                this.dataFormId = response.data ? response.data.formDataId : '';
                this.vdCustomFileUploadService.formDataIdChanges.next({
                    dataFormId: this.dataFormId
                });
            }
            this.getDocuments();
            fubauto.clear();
        });
    }
    getDocuments() {
        if (this.configurations.getApiUrl &&
            (!this.configurations.isFormBuilder || (this.configurations.isFormBuilder && this.dataFormId))) {
            let apiUrl = this.configurations.getApiUrl;
            if (this.configurations.familyId) {
                apiUrl = `${this.configurations.getApiUrl}?familyId=${this.configurations.familyId}`;
            }
            if (this.configurations.isFormBuilder) {
                apiUrl = `${apiUrl}` + `${this.dataFormId}`;
            }
            this.uploadService.getUploadedDocument(apiUrl)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                this.uploadedFiles = Object.assign([], response.data);
                this.cdr.detectChanges();
            });
        }
    }
    openDoc(item) {
        if (this.configurations.isFormBuilder) {
            const docPath = item.fileLocation;
            window.open(`${environment.appUrl}${docPath}`, '_blank');
        }
        else {
            const docPath = item.fileLocation.substring(23);
            window.open(`${environment.docs}${docPath}`, '_blank');
        }
    }
    download(file) {
        if (this.configurations.isFormBuilder) {
            this.uploadService.downloadDocuments(environment.appUrl + file.fileLocation, file.fileName);
        }
        else {
            this.uploadService.downloadDocuments(environment.docs + file.fileLocation.substring(23), file.fileLocation.substring(23));
        }
    }
    deleteDocumentTypeLis(input) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.uploadService.deleteUploadDocument(this.configurations.deleteApiUrl + `${input.id}`)
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((responseUploadedDocs) => {
                    this.toasterService.success(responseUploadedDocs.message, 'Success');
                    this.getDocuments();
                });
            }
        });
    }
    downloadTemplateFile() {
        this.CreateProjectTimesheetService.downloadTemplate()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.data) {
                const path = environment.docs + response.data.replace('/var/imagility/uploads/', '');
                this.CreateProjectTimesheetService.downloadTemplateDocument(path, "Timesheet Format");
            }
        });
    }
    uploadtoggle(data, e) {
        var _a, _b;
        const value = e.target.value || data;
        if (data == 1 && this.isChecked == false) {
            (_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
            this.confirmationService.confirm({
                header: 'Confirmation',
                message: 'Are you sure you want to proceed to Upload Timesheet?',
                acceptIcon: 'pi pi-check mr-2',
                rejectIcon: 'pi pi-times mr-2',
                rejectButtonStyleClass: 'p-button-sm',
                acceptButtonStyleClass: 'p-button-outlined p-button-sm',
                accept: () => {
                    this.isChecked = true;
                    this.confirm('Yes', "1");
                },
                reject: () => {
                    this.isChecked = false;
                    this.confirm('No', "2");
                }
            });
        }
        else if (data == 2 && this.isChecked == true) {
            (_b = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _b === void 0 ? void 0 : _b.call(e);
            this.confirmationService.confirm({
                header: 'Confirmation',
                message: 'Are you sure you want to proceed to Manual Timesheet entry?',
                acceptIcon: 'pi pi-check mr-2',
                rejectIcon: 'pi pi-times mr-2',
                rejectButtonStyleClass: 'p-button-sm',
                acceptButtonStyleClass: 'p-button-outlined p-button-sm',
                accept: () => {
                    this.isChecked = false;
                    this.confirm('Yes', "2");
                    const payload = new FormData();
                    payload.delete('file');
                },
                reject: () => {
                    this.isChecked = true;
                    this.confirm('No', "1");
                }
            });
        }
        else {
            e.preventDefault();
        }
    }
    confirm(mode, data) {
        this.projecttimesheetForm.get('type').setValue(data);
        this.VdCustomFileUploadService.sendtimesheetCheckbocValue(this.isChecked);
    }
    FileUpload(event) {
        this.getFile = event.files[0];
        this.filepayload.append('file', this.getFile);
        this.fileName = event.files[0].name;
        this.disableFileUpload = true;
    }
    clear() {
        var _a;
        this.disableFileUpload = false;
        (_a = this.credential) === null || _a === void 0 ? void 0 : _a.clear();
        this.filepayload.delete('file');
    }
    saveDocument() {
        let getModuleId = sessionStorage.getItem('moduleId');
        this.CreateProjectTimesheetService.uploadDocument(getModuleId, this.filepayload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a;
            if ((response === null || response === void 0 ? void 0 : response.status) == 200) {
                this.disableFileUpload = true;
                this.toastr.success(response === null || response === void 0 ? void 0 : response.message, 'Success');
                this.getUploadFilesResponse = response === null || response === void 0 ? void 0 : response.data;
                //this.toastr.success("File saved Successfuly", 'Success');
                let pageFormId = JSON.parse(sessionStorage.getItem("selectedMenu"));
                pageFormId = pageFormId.pageFormId;
                if (pageFormId) {
                    this.customButtonActionService.getPageFormById(pageFormId)
                        .pipe(take(1)).subscribe((response) => {
                        if (response) {
                            const item = {
                                formType: response.buildFormatTypeId,
                                pageFormId: response.id
                            };
                            this.customButtonActionService.onLinkRedirectPageSubject.next(item);
                        }
                    });
                }
            }
            else {
                CustomErrorToastComponent.showErrorToast(this.toastr, response === null || response === void 0 ? void 0 : response.message);
            }
            (_a = this.credential) === null || _a === void 0 ? void 0 : _a.clear();
        });
    }
    //get project type dropdown value
    getProjectDetailsByDate(isEdit) {
        console.log(this.projecttimesheetForm);
        const fromDateString = moment(this.projecttimesheetForm.get('fromDate').value).format('MM/DD/YYYY');
        this.CreateProjectTimesheetService
            .getTimeSheetDetails(fromDateString).pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.loading = false;
            this.getProjectList = (response === null || response === void 0 ? void 0 : response.data) || [{ id: 0, name: "Select Project", otherCode: 0, isDisable: true }];
            if (response === null || response === void 0 ? void 0 : response.data) {
                this.getProjectList.forEach((item, index) => {
                    item["isDisable"] = false;
                    item["id"] = parseInt(item["id"]);
                });
                if (!isEdit) {
                    this.prepareProjectTimesheet();
                }
                else {
                    this.timesheetArrObj.forEach(el => el.editable = true);
                }
            }
            this.cdr.detectChanges();
        });
    }
    // create timesheet object  
    prepareProjectTimesheet() {
        //get the start and 
        this.timesheetArrObj = [];
        let startDate = this.projecttimesheetForm.get('fromDate').value;
        let endDate = this.projecttimesheetForm.get('toDate').value;
        let datesInBetween = this.getDates(startDate, endDate);
        if (datesInBetween.length > 0) {
            datesInBetween.forEach(item => {
                this.datesArr.push(moment(item).format('YYYY-MM-DD'));
                this.timesheetArrObj.push({
                    date: moment(item).format('YYYY-MM-DD'),
                    details: [{
                            activity: '',
                            projectId: '',
                            time: 0,
                            projectName: ''
                        }],
                    dailyTotal: 0,
                    editable: true
                });
            });
        }
        this.cdr.detectChanges();
    }
    getDates(start, end) {
        const arr = [];
        for (const dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
            arr.push(new Date(dt));
        }
        return arr;
    }
    deleteRow(i, item) {
        item.details.splice(i, 1);
    }
    addRow(item) {
        item.details.push({
            activity: '',
            projectId: '',
            time: 0,
            projectName: ''
        });
        console.log(this.timesheetArrObj);
    }
    getProjectValue(e, i, item) {
        console.log('here');
        console.log(e);
        this.setRowEditable(e.value, item);
    }
    setRowEditable(val, item) {
        var _a;
        let projectDuration = (_a = this.getProjectList.find(item => item.id == val)) === null || _a === void 0 ? void 0 : _a.otherCode.split('-');
        let projStart = projectDuration[0];
        let projEnd = projectDuration[1];
        if (moment(item.date).isSameOrAfter(moment(projStart)) &&
            moment(item.date).isSameOrBefore(moment(projEnd))) {
            item.editable = true;
        }
        else {
            item.editable = false;
        }
    }
    resetToDate() {
        console.log('fsdfdsfdsfsdfsfsf');
        this.projecttimesheetForm.get('toDate').setValue(null);
        this.projecttimesheetForm.get('toDate').updateValueAndValidity();
    }
    setFormData(e, type, item, i) {
        if (type === 'time') {
            item.details[i][type] = e.value;
        }
        if (type === 'projectId') {
            item.details[i]['projectName'] = this.getProjectList.find(el => el.id == item.details[i].projectId).name;
        }
        this.projecttimesheetForm.get('projectTimesheetDetails').setValue(this.timesheetArrObj);
        console.log('here----', this.projecttimesheetForm);
        console.log('hereee----', this.timesheetArrObj);
        if (type === 'time') {
            this.updateDailyTotal();
        }
    }
    updateDailyTotal() {
        this.timesheetArrObj.forEach(item => {
            item.dailyTotal = 0;
            let total = 0;
            item.details.forEach(obj => {
                total += obj.time;
            });
            item.dailyTotal = total;
        });
        this.projecttimesheetForm.get('projectTimesheetDetails').setValue(this.timesheetArrObj);
        console.log('updated---', this.timesheetArrObj);
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.isChecked = true;
        this.VdCustomFileUploadService.sendtimesheetCheckbocValue(this.isChecked);
    }
}
CreateProjectTimesheetComponent.ɵfac = function CreateProjectTimesheetComponent_Factory(t) { return new (t || CreateProjectTimesheetComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(CreateProjectTimesheetService), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.CustomButtonActionService), i0.ɵɵdirectiveInject(i5.VdCustomFileUploadService), i0.ɵɵdirectiveInject(i6.ConfirmationService), i0.ɵɵdirectiveInject(i6.MessageService), i0.ɵɵdirectiveInject(i6.PrimeNGConfig), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i7.FileUploadLibraryService), i0.ɵɵdirectiveInject(i5.VdCustomFileUploadService), i0.ɵɵdirectiveInject(i8.DialogService), i0.ɵɵdirectiveInject(i9.ReferenceLibraryService), i0.ɵɵdirectiveInject(i10.DatePipe)); };
CreateProjectTimesheetComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CreateProjectTimesheetComponent, selectors: [["create-project-timesheet"]], viewQuery: function CreateProjectTimesheetComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
        i0.ɵɵviewQuery(_c1, 1);
        i0.ɵɵviewQuery(_c2, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.credential = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fubauto = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropDownThing = _t.first);
    } }, inputs: { formBuilderInfo: "formBuilderInfo", group: "group", inputParams: "inputParams" }, features: [i0.ɵɵProvidersFeature([ConfirmationService, MessageService])], decls: 5, vars: 1, consts: [[1, "flex", "justify-content-center", "create_project_timesheet_dialog"], ["pTemplate", "message"], [3, "formGroup", 4, "ngIf"], [1, "flex", "flex-column", "align-items-center", "w-full", "gap-3", "border-bottom-1", "surface-border"], [1, "pi", "pi-exclamation-circle", "text-6xl", "text-primary-500"], [3, "formGroup"], ["class", "container-fluid create_project_timesheet p-0 mt-2 mb-2 pb-3", 4, "ngIf"], ["class", "row mb-2 mt-2", 4, "ngIf"], [3, "ngClass"], [1, "label-cls", "col", "d-block", "pl-0", "mb-2", "mt-2"], [1, "row", "d-flex-align-items-end", 3, "ngClass"], ["class", "pt-1  processing-dropdown margin-top-3-percentage", 4, "ngIf"], ["class", "col-md-4 p-0 px-2", 4, "ngIf"], ["class", "ml-2 pt-1 margin-top-3-percentage", 4, "ngIf"], [1, "mb-5", "pt-2", "fileContentSection", 3, "ngClass"], [1, "labelText"], ["styleClass", "vdFileUploadTable", "name", "uploadedFiles", "scrollHeight", "120px", 1, "pa-table", 3, "value", "scrollable"], ["pTemplate", "header"], ["pTemplate", "body"], [1, "container-fluid", "create_project_timesheet", "p-0", "mt-2", "mb-2", "pb-3"], ["class", "row", 4, "ngIf"], ["class", "row", 3, "ngClass", 4, "ngIf"], [1, "row", "mt-2", "pb-3"], [1, "col-3", "col-lg-3"], [1, "w-800", "pr-3"], ["id", "fromDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "formControlName", "fromDate", "yearNavigator", "true", "monthNavigator", "true", "inputId", "icon", "placeholder", "MM-DD-YYYY", "dateFormat", "mm/dd/yy", "name", "fromDate", 1, "im-input-calendar", 3, "showIcon", "maxDate", "onSelect"], ["id", "toDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "formControlName", "toDate", "yearNavigator", "true", "monthNavigator", "true", "inputId", "icon", "placeholder", "MM-DD-YYYY", "dateFormat", "mm/dd/yy", "name", "toDate", 1, "im-input-calendar", 3, "showIcon", "maxDate", "disabled", "onSelect"], [1, "row"], ["class", "col-12", 4, "ngFor", "ngForOf"], [1, "col-12"], ["class", "mr-4 mb-3 mt-3", "name", "type", "value", "1", "label", "Upload Timesheet", "formControlName", "type", "inputId", "1", 3, "click", 4, "ngIf"], ["name", "type", "label", "Manual Entry", "formControlName", "type", "inputId", "2", 1, "mr-4", "mb-3", "mt-3", 3, "value", "click"], ["name", "type", "value", "1", "label", "Upload Timesheet", "formControlName", "type", "inputId", "1", 1, "mr-4", "mb-3", "mt-3", 3, "click"], [1, "row", 3, "ngClass"], [1, "add_more_btn", 3, "click"], [1, "pi", "pi-download"], [1, "col-12", "upload_section", "pb-3", "mb-3"], [1, "flex", "justify-content-center"], [1, "flex", "flex-wrap", "gap-3", "mr-4", "mb-3", "mt-3"], ["chooseIcon", "pi pi-upload", "mode", "basic", "customUpload", "true", "name", "demo[]", "accept", ".csv,.xlsx,.xls", "chooseLabel", "Upload", 1, "bulk_upload", 3, "disabled", "auto", "uploadHandler"], ["credential", ""], ["class", "col-12", 4, "ngIf"], [1, "row", "mb-4"], [1, "col-1"], ["type", "button", 1, "btn_width", "btn", "btn-success", "button-width-icon-left", 3, "disabled", "click"], [1, "col-2"], ["type", "button", 1, "btn_width", "btn", "btn-secondary", "button-width-icon-left", "mr-3", 3, "click"], [1, "w-600"], ["styleClass", "p-datatable-striped", "scrollHeight", "300px", 3, "value", "selectionMode"], ["pTemplate", "footer"], [2, "width", "85px"], [2, "width", "100px"], [2, "width", "250px"], [2, "width", "50px"], [1, "pr-0", 2, "width", "85px"], ["type", "button", "title", "Delete", "pButton", "", "icon", "pi pi-trash", "class", "p-button-text p-button-rounded", 3, "disabled", "click", 4, "ngIf"], ["inputId", "id", "appendTo", "body", "name", "projectId", "placeholder", "Select Project", "optionLabel", "name", "optionValue", "id", 3, "ngModel", "ngModelOptions", "options", "autoDisplayFirst", "ngModelChange", "onChange"], ["pKeyFilter", "int", "pInputText", "", "placeholder", "Enter the task", "type", "text", "maxlength", "200", 1, "im-input", "w-100", 3, "ngModelOptions", "ngModel", "disabled", "ngModelChange", "change"], ["appendTo", "body", "inputId", "integeronly", 3, "ngModel", "ngModelOptions", "min", "max", "disabled", "ngModelChange", "onInput"], ["type", "button", "title", "Add", "pButton", "", "icon", "pi pi-plus", "class", "p-button-text p-button-rounded", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "title", "Delete", "pButton", "", "icon", "pi pi-trash", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], ["type", "button", "title", "Add", "pButton", "", "icon", "pi pi-plus", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], ["colspan", "3"], [1, "weekdaysHour"], [4, "ngIf"], ["colspan", "10", 1, "error"], [1, "row", "mb-2", "mt-2"], [1, "pt-1", "processing-dropdown", "margin-top-3-percentage"], ["appendTo", "body", "placeholder", "Select Category", "optionValue", "code", "optionLabel", "name", 3, "disabled", "options", "ngModel", "autoDisplayFirst", "ngModelChange", "onChange", 4, "ngIf"], ["appendTo", "body", "placeholder", "Select Category", "optionValue", "code", "optionLabel", "name", 3, "disabled", "options", "ngModel", "autoDisplayFirst", "ngModelChange", "onChange"], ["dropDownThing", ""], [1, "col-md-4", "p-0", "px-2"], [1, "mb-0"], ["type", "text", "pInputText", "", 3, "ngModel", "ngModelChange"], [1, "ml-2", "pt-1", "margin-top-3-percentage"], ["mode", "basic", "customUpload", "true", "name", "demo[]", "accept", ".pdf", "chooseLabel", "Browse & Upload", 3, "disabled", "auto", "uploadHandler"], ["fubauto", ""], ["colspan", "2"], [2, "cursor", "pointer", 3, "click"], ["nowrap", ""], [1, "d-flex", "flex-row", "documents-icons", "d-flex", "align-items-center"], ["class", "mr-2 padding0", 4, "ngIf"], [1, "mr-2", "padding0"], ["pButton", "", "type", "button", "icon", "pi pi-eye", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], ["pButton", "", "type", "button", "icon", "pi pi-download", "pTooltip", "Download", 1, "p-button-text", "p-button-rounded", 3, "click"], ["pButton", "", "type", "button", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"]], template: function CreateProjectTimesheetComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "p-toast");
        i0.ɵɵelementStart(2, "p-confirmDialog");
        i0.ɵɵtemplate(3, CreateProjectTimesheetComponent_ng_template_3_Template, 4, 1, "ng-template", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, CreateProjectTimesheetComponent_form_4_Template, 16, 17, "form", 2);
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.projecttimesheetForm);
    } }, directives: [i11.Toast, i12.ConfirmDialog, i6.PrimeTemplate, i10.NgIf, i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i10.NgClass, i13.Table, i14.Calendar, i1$1.NgControlStatus, i1$1.FormControlName, i10.NgForOf, i15.RadioButton, i16.FileUpload, i17.Dropdown, i1$1.NgModel, i1$1.DefaultValueAccessor, i18.InputText, i1$1.MaxLengthValidator, i19.InputNumber, i20.ButtonDirective, i21.Tooltip], pipes: [i10.DatePipe], styles: [".create_project_timesheet[_ngcontent-%COMP%]   .add_more_btn[_ngcontent-%COMP%]{color:#1aa0da;text-decoration:underline;cursor:pointer}.create_project_timesheet[_ngcontent-%COMP%]   .weekdaysHour[_ngcontent-%COMP%]{font-weight:400;font-size:14px}.create_project_timesheet[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font-weight:600}.create_project_timesheet[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}.docInput[_ngcontent-%COMP%]{display:inline-block;width:15px;height:15px!important;margin-bottom:0}.p-fileupload.p-fileupload-basic.p-component[_ngcontent-%COMP%]{border:1px solid #ccc!important;text-align:right!important;border-radius:5px!important}.disabledView[_ngcontent-%COMP%]{display:none}h6[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px;font-weight:400}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateProjectTimesheetComponent, [{
        type: Component,
        args: [{
                selector: "create-project-timesheet",
                templateUrl: "create-project-timesheet.component.html",
                styleUrls: ["create-project-timesheet.component.scss"],
                providers: [ConfirmationService, MessageService],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i0.ChangeDetectorRef }, { type: CreateProjectTimesheetService }, { type: i3.ToastrService }, { type: i4.CustomButtonActionService }, { type: i5.VdCustomFileUploadService }, { type: i6.ConfirmationService }, { type: i6.MessageService }, { type: i6.PrimeNGConfig }, { type: i3.ToastrService }, { type: i7.FileUploadLibraryService }, { type: i5.VdCustomFileUploadService }, { type: i8.DialogService }, { type: i9.ReferenceLibraryService }, { type: i10.DatePipe }]; }, { formBuilderInfo: [{
            type: Input
        }], group: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], credential: [{
            type: ViewChild,
            args: ['credential', { static: false }]
        }], fubauto: [{
            type: ViewChild,
            args: ['fubauto', { static: false }]
        }], dropDownThing: [{
            type: ViewChild,
            args: ['dropDownThing']
        }] }); })();

class CreateProjectTimesheetModule {
}
CreateProjectTimesheetModule.ɵfac = function CreateProjectTimesheetModule_Factory(t) { return new (t || CreateProjectTimesheetModule)(); };
CreateProjectTimesheetModule.ɵmod = i0.ɵɵdefineNgModule({ type: CreateProjectTimesheetModule });
CreateProjectTimesheetModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            ReactiveFormsModule,
            PrimengLibraryModule,
            MessageModule,
            MessagesModule,
            ToastModule,
            ConfirmPopupModule,
            StyleClassModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CreateProjectTimesheetModule, { declarations: [CreateProjectTimesheetComponent], imports: [FormsModule,
        ReactiveFormsModule,
        PrimengLibraryModule,
        MessageModule,
        MessagesModule,
        ToastModule,
        ConfirmPopupModule,
        StyleClassModule], exports: [CreateProjectTimesheetComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateProjectTimesheetModule, [{
        type: NgModule,
        args: [{
                declarations: [CreateProjectTimesheetComponent],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    PrimengLibraryModule,
                    MessageModule,
                    MessagesModule,
                    ToastModule,
                    ConfirmPopupModule,
                    StyleClassModule
                ],
                exports: [CreateProjectTimesheetComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of create-project-timesheet
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CreateProjectTimesheetComponent, CreateProjectTimesheetModule, CreateProjectTimesheetService };
//# sourceMappingURL=create-project-timesheet.js.map
